import graphql__9625abbb51175eacfb64 from "./__generated__/LinkSlide_slide.graphql.js";import { forwardRef, useCallback } from "react";
import { graphql, useFragment } from "react-relay";
import { omit } from "lodash";

import { useUniqueId } from "../Utils/uniqueId";
import { useNavigateTo } from "../Routes/RoutesContext";
import { useIsLibraryFileUrl } from "../Utils/libraryLinks";

const LinkSlide = (props, ref) => {
  // Passthrough props include Nuka-carousel provided accessibility related props like
  // aria-hidden and tabIndex props.
  const { url } = useFragment(LinkSlide_slide, props.slide);
  const passthroughProps = omit(props, "slide");
  const id = useUniqueId("carousel-slide");

  const isLibraryFileUrl = useIsLibraryFileUrl();

  const navigateTo = useNavigateTo();
  // We need to manually handle navigation to bypass the Nuka Carousel plugin
  const handleClick = useCallback(() => {
    if (!url) return;

    // We want to let the ExternalLinksManager handle library file links so the current
    // page doesn't navigate to a non-router URL.
    if (isLibraryFileUrl(url)) return;

    navigateTo(url);
  }, [isLibraryFileUrl, navigateTo, url]);

  return (
    <a
      id={id}
      className="slide-container"
      href={url}
      onClick={handleClick}
      ref={ref}
      {...passthroughProps}
    >
      {props.children}
    </a>
  );
};

const LinkSlide_slide = graphql__9625abbb51175eacfb64;

export default forwardRef(LinkSlide);
